import Fbx from '@/common/Fbx.js';
import http from '@/common/http.js'
import config from '@/common/config.js';
import fileUtil from '@/common/FileUtil.js';
import { uuid } from 'vue-uuid';
import md5 from 'js-md5';

let tasks	= [];		//上传任务队列
let xhr		= null;		//当前上传的xhr对象
let busy	= false;

//卸载
function unload(){
	while(tasks.shift());
	xhr && xhr.abort();
	xhr = null;
}

function ossUpload(params){
	let task = uni.uploadFile({
		url: params.host,
		file: params.file,
		name: 'file',
		timeout: 3600000, //上传文件超时时间为一小时
		formData: params.form,
		success: (res) => {
			params.success && params.success(res.data);
		},
		fail: (err) => {
			params.error && params.error(err);
		}
	});
	
	//上传进度
	task.onProgressUpdate((res) => {
		params.progress && params.progress(res.progress);
	});
}

function uploadTask(){
	
	if(busy || tasks.length <=0) return;
	
	busy = true;
	
	let task = tasks.shift();

	xhr = ossUpload({
		file	: task.file,
		form	: task.form,
		host	: task.host,
		success	: (res) => {	//上传完成
			busy = false;
			task.success && task.success(res);
			uploadTask();
		}, 
		progress: (res) => {	//上传进度
			task.progress && task.progress(res);
		},
		error	: (res) =>{		//上传出错
			busy = false;
			task.error && task.error(res);
			uploadTask();
		}
	});
}

function upload(params){
	let projectId	= params.form.id;
	let resourceId	= md5(uuid.v4()).substr(16);
	let file = '';
	let path = '';
	
	let extName		= fileUtil.extName(params.file.name).toLowerCase();
	
	switch(params.form.type){
		case 'hotspotIconImage':
		case 'hotspotImage':
		case 'hotspotIconVideo':
		case 'hotspotVideo':
			file = 'img/' + resourceId + '.' + extName;
			path = 'vr';
			break;
			
		case 'music':
			file = 'img/' + resourceId + '.mp3';
			path = 'vr';
			break;
			
		case 'logo':
			file = 'img/' + resourceId + '.' + extName;
			path = 'vr';
			break;
			
		case 'fov':
			file = 'img/' + resourceId + '.jpg';
			path = 'vr';
			break;
		case 'share':
			file = 'img/' + resourceId + '.' + extName;
			path = 'vr';
			break;
			
		//小程序验证
		case 'miniProgram':
			file = 'img/' + params.file.name;
			path = 'vr';
			break;
			
		default:
			file = 'img/' + resourceId + '.' + extName;
			path = 'vr';
			break;
	}

	//文件大小
	let size = dyConfig.getSize();
	size.user += Number(params.file.size);
	
	getToken(projectId, path, size, res=>{
		let token = dyEditor.getToken();
		
		return ossUpload({
			file	: params.file,
			host	: 'https://' + res.host,
			form	: {
				AccessKeyId			: res.accessid,
				policy				: res.policy,
				signature			: res.signature,
				key					: res.dir + 'img/' + resourceId + '.' + extName,
				"x-obs-meta-token"	: token,
				//"x-obs-expires"		: res.expires
			},
			success	: (res) => {	//上传完成
				params.success && params.success({resourceId, file});
			}, 
			progress: (res) => {	//上传进度
				params.progress && params.progress(res);
			},
			error	: (res) =>{		//上传出错
				params.error && params.error(res);
			}
		});
	});
}

function getToken(projectId, path, size, success){
	if(dyEditor.user.storage.used > dyEditor.user.storage.total - 1024*1024){
		dyEditor.dialog.storage({
			title	:'空间容量不足',
			storage	: {
				goProject : ()=>{
					window.open('#/pages/index/index', '_blank');
				},
				goShop : ()=>{
					window.open(dyConfig.shop, '_blank'); 
				}
			}
		});
		
		return;
	}
	
	let token = dyEditor.getToken();
	if(!token) {
		console.log('getToken is null');
		return;
	}
	uni.request({
		method:'POST',
		url: config.api + '/auth/get',
		header:{ token },
		data:{
			projectId:projectId,
			path:path,
			size:size,
		},
		success:res=>{
			switch(Number(res.data.code)){
				case 0:		//完成
					success && success(res.data.data);
					break;
					
				case 50002:	//空间不足
					dyEditor.dialog.storage2({
						title	:'系统提示',
						storage	: {
							goShop : ()=>{
								window.open(dyConfig.shop, '_blank'); 
							}
						}
					});
					break;
			}
		}
	})
}

function uploadFiles(projectId, files, params){
	let file 		= '';
	let path 		= '';
	
	switch(params.type){
		case 'hotspotIconImage':
		case 'hotspotImage':
		case 'hotspotIconVideo':
		case 'hotspotVideo':
		case 'hotspotContactImage':
		case 'hotspotModel':
			path = 'vr';
			break;
		default:
			path = 'user';
			break;
	}
	
	let totalSize = 0;
	//预先检查用户空间是否够上传
	for(let i=0; i<files.length; i++){
		totalSize += Number(files[i].size);
	}
	
	//文件大小
	let size = dyConfig.getSize();
	size.user += Number(totalSize);
	
	getToken(projectId, path, size, res=>{
		for(let i=0; i<files.length; i++){
			let f = files[i];			
			let extName		= fileUtil.extName(f.name).toLowerCase();
			let firstName	= fileUtil.firstName(f.name);
			let resourceId	= md5(uuid.v4()).substr(16);
			let token		= dyEditor.getToken();
			let item		= {};
			 			
			switch(params.type){
				case 'hotspotIconImage':
				case 'hotspotImage':
				case 'hotspotIconVideo':
				case 'hotspotVideo':
				case 'hotspotContactImage':
				case 'hotspotModel':
					file = 'img/' + resourceId + '.' + extName;
					break;
				default:
					file = resourceId + '.' + extName;
					break;
			}
			
			let form = {
				AccessKeyId			: res.accessid,
				policy				: res.policy,
				signature			: res.signature,
				key					: res.dir + file,
				"x-obs-meta-token"	: token,
			}
			
			if(res.expires){
				form["x-obs-expires"] = res.expires;
			}
			
			if(params.ready)
			{
				item = params.ready({
					id		: resourceId,
					name	: firstName,
					size	: f.size,
					extName	: extName,
					file	: file,
					data	: f,
				});
			}
			
			//上传文件
			tasks.push({
				file	: f,
				host	: 'https://' + res.host,		
				form	: form,
				success	: (r)=>{
					//res.item = item;
					let res = {item};
					params.success && params.success(res);
				},
				progress: (num)=>{
					params.progress && params.progress({item,num});
				},
				error: (res)=>{
					res.item = item;
					params.error && params.error(res);
				}
			});
			
			uploadTask();
		}
	});
}

//ai推演
function pano2dyc(params,callback){
	http.request({
		url		: 'ai/pano2dyc',
		data	: params,
		success: (res)=> {
			callback && callback(res);
		}
	})
}

//推演状态
function pano2dyc_info(params,callback){
	http.request({
		url		: 'ai/pano2dyc_info',
		data	: params,
		success: (res)=> {
			callback && callback(res);
		}
	})
}

export default {
	upload			: upload,
	uploadFiles		: uploadFiles,
	unload			: unload,	//这个是unload不是上面那个upload
	pano2dyc		: pano2dyc,
	pano2dyc_info	: pano2dyc_info,
}